import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { startAppUpdateWatcher } from './utils/appUpdate';

// Static pages served at a clean URL (topbred.com/analysis). The deploy uploads them under their bare name too;
// if a request still reaches the app (the local dev server, or a stale cache), hand over to the .html file
// instead of showing the sign-in form.
const STATIC_PAGES = ['/analysis', '/privacy'];
const path = window.location.pathname.replace(/\/$/, '') || '/';
const staticPage = STATIC_PAGES.find((p) => path === p);

// topbred.com is the video analysis page for anyone who isn't signed in; signed-in users get the app as before.
// The app's few users sign in from the link on that page, or at /signin.
const signedIn = (() => { try { return !!localStorage.getItem('access_token'); } catch { return false; } })();
const homeForVisitor = !signedIn && (path === '/' || path === '/index.html');

if (staticPage) {
  window.location.replace(staticPage + '.html' + window.location.search + window.location.hash);
} else if (homeForVisitor) {
  window.location.replace('/analysis' + window.location.search + window.location.hash);
} else {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  startAppUpdateWatcher();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
